import { useCallback } from 'react';
import PropTypes from 'prop-types';
import Grid from '@mui/material/Grid';
import { useHandleShowDialogs } from 'forms/hooks';
import { includes } from 'ramda';
import { useDispatch } from 'react-redux';

import SubmitButton from '@gef-ui/form-material/SubmitButton';
import { getLabelMessage } from '@gef-ui/localization/messages';

import { ComponentLoader } from 'components/index';
import { useIgnoreErrorsWhen } from 'components/molecules/ComponentLoader/hooks';
import { urls } from 'features/common/fetch/constants';
import { tryRedirectTask } from 'features/views/taskForwarding/actions';
import {
	TASK_FORWARDING_ALREADY_PROCESSED,
	TASK_FORWARDING_HAS_NO_ACCESS_ERR_MSG,
} from 'features/views/taskForwarding/constants';
import { TASK_FORWARDING_FORM_NAME } from 'features/views/taskForwarding/form';

export const ActionButtons = () => {
	const dispatch = useDispatch();
	const handleSubmit = useCallback(() => {
		dispatch(tryRedirectTask());
	}, [dispatch]);

	const handleShowDialogsForAddSubmit = useHandleShowDialogs({
		page: TASK_FORWARDING_FORM_NAME,
		mapper: {
			loginOrSellerInOrUserSurname: ['login', 'sellerIn', 'userSurname'],
		},
		continueFn: handleSubmit,
	});

	const ignoreErrorsForTaskRedirectHasNoAccess = useIgnoreErrorsWhen({
		fetchStorePath: urls.taskRedirect,
		attributePath: ['metaData', 'parsedContent', 'message'],
		condition: (value) => includes(TASK_FORWARDING_HAS_NO_ACCESS_ERR_MSG, value),
	});

	const ignoreErrorsForTaskRedirectFail = useIgnoreErrorsWhen({
		fetchStorePath: urls.taskRedirect,
		attributePath: ['metaData', 'parsedContent', 'code'],
		value: TASK_FORWARDING_ALREADY_PROCESSED,
	});

	return (
		<Grid container>
			<Grid size={12}>
				<Grid container justifyContent="space-around">
					<Grid size={3}>
						<ComponentLoader
							fetchStorePath={urls.taskRedirect}
							ignoreErrors={ignoreErrorsForTaskRedirectHasNoAccess || ignoreErrorsForTaskRedirectFail}
						>
							<SubmitButton
								variant="contained"
								onClick={handleSubmit}
								onClickError={handleShowDialogsForAddSubmit}
								fullWidth
								text={getLabelMessage('taskForwarding:forward')}
							/>
						</ComponentLoader>
					</Grid>
				</Grid>
			</Grid>
		</Grid>
	);
};

ActionButtons.propTypes = {
	formName: PropTypes.object,
};

export default ActionButtons;
